import * as reducers from './reducers'

export const constants = {
  NAME: 'analytics'
}

export default { constants, reducers}